module.exports = __webpack_public_path__ + "static/media/circle-cancel-blue.c75945ce.svg";